import React, { useState, useEffect } from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';
import { triggerApplyModal } from '../App';
import './Navbar.css';

const Navbar = ({ onOpenForm }) => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleApplyClick = (e) => {
    e.preventDefault();
    if (onOpenForm) {
      onOpenForm();
    } else {
      triggerApplyModal();
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  
  if (
    location.pathname === '/moneybro' ||
    location.pathname === '/paisadaily'
  ) {
    return null;
  }

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <Link to="/" className="logo" aria-label="Kubersetu Home">
            <Logo height={38} light={true} />
          </Link>

          <div className="nav-links">
            <ul>
              <li>
                <Link to="/" className="nav-link">Home</Link>
              </li>
              <li>
                <Link to="/services" className="nav-link">Services</Link>
              </li>
              <li>
                <Link to="/products" className="nav-link">Products</Link>
              </li>
              <li>
                <Link to="/about" className="nav-link">About Us</Link>
              </li>
              <li>
                <Link to="/contact" className="nav-link">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div className="nav-actions">
            <button 
              type="button"
              onClick={handleApplyClick}
              className="nav-btn-primary"
            >
              Apply Now <FiArrowUpRight />
            </button>
          </div>

          <button 
            className={`mobile-menu-btn ${mobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
        <Link to="/" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Home</Link>
        <Link to="/services" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Services</Link>
        <Link to="/products" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Products</Link>
        <Link to="/about" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>About Us</Link>
        <Link to="/contact" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Contact Us</Link>
        
        <div className="mobile-actions">
          <button 
            type="button"
            className="btn btn-primary" 
            style={{ width: '100%', display: 'block', textAlign: 'center' }}
            onClick={(e) => {
              setMobileMenuOpen(false);
              handleApplyClick(e);
            }}
          >
            Apply Now <FiArrowUpRight />
          </button>
        </div>
      </div>
    </>
  );
};

export default Navbar;